export default "__VITE_ASSET__Bu0$pKQg__"